import createCheckPermissionsHook from './createCheckPermissionsHook';
import createWithPermissionsWrapper from '../components/WithPermission/createWithPermissionsWrapper';
import { WithPermissions } from './models/withPermissions';
import { useAppSelector } from '../redux/hooks';

interface PermissionCheckers {
  checkPermissions: (
    _permissions?: string | string[] | null | undefined,
    _checkAll?: boolean | undefined
  ) => boolean;
  withPermissions: WithPermissions;
}

export default function createPermissionCheckers(): PermissionCheckers {
  const modules = useAppSelector((state) => state.coach.coach.userGroup?.modules);
  const THE_AVAILABLE_PERMISSIONS = modules.flatMap((module) =>
    module.UserPermissions.map((permission) => permission.permissionCode)
  );

  const useCheckPermissions = createCheckPermissionsHook(() => THE_AVAILABLE_PERMISSIONS);
  const withPermissions = createWithPermissionsWrapper(useCheckPermissions);
  const { checkPermissions } = useCheckPermissions();
  return {
    checkPermissions,
    withPermissions,
  };
}
